import Vue from 'vue'
import * as userTypes from '@/store/actions/user'
import * as authTypes from '@/store/actions/auth'

const state = {
  status: '',
  gender: '',
  name: '',
  googleMapsApiKey: ''
}

const getters = {
  [userTypes.USER_PROFILE]: state => state.name,
  [userTypes.USER_PROFILE_LOADED]: state => !!state.name,
  [userTypes.USER_API_GOOGLE_MAPS_KEY]: state => state.googleMapsApiKey
}

const actions = {
  [userTypes.USER_REQUEST]: ({commit, dispatch}, profile) => {
    commit(userTypes.USER_SUCCESS, profile)
  },
  [authTypes.AUTH_LOGOUT]: ({commit, dispatch}) => {
    commit(authTypes.AUTH_LOGOUT)
  }
}

const mutations = {
  [userTypes.USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [userTypes.USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.gender = resp.gender
    state.name = resp.name
    // servei provisional
    // state.googleMapsApiKey = resp.googleMapsApiKey
    state.googleMapsApiKey = Vue.config.sherpaCrm.API_GOOGLE_MAPS_KEY
  },
  [userTypes.USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [authTypes.AUTH_LOGOUT]: (state) => {
    state.gender = ''
    state.name = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js